export class ResponseTile {
  public index: number;
  public text: string;
  public highlight: boolean;
  public isCorrect: boolean;

  constructor(index: number, text: string, highlight: boolean, isCorrect: boolean) {
    this.index = index;
    this.text = text;
    this.highlight = highlight;
    this.isCorrect = isCorrect;
  }
}